import { Box, Grid, Typography } from "@mui/material"
import noTrackerIcon from '../../../../assets/icons/noTrackersIcon.svg'
import { useTranslation } from "react-i18next"
import { EmptyContainer } from "../../../../components/KeydriveComponents/EmptyContainer/EmptyContainer";

export const NoTrackerView = () => {

    const { t } = useTranslation();

    return (
        <Grid
            container
            display="flex"
            justifyContent="center"
            alignItems="center"
            border="1px solid #0000001A"
            borderRadius="4px"
            height="85%"
            padding={4}
        >
            <EmptyContainer 
                icon={
                    <Box 
                        component="img"
                        src={noTrackerIcon}
                        width="100px"
                        marginBottom="20px"
                    />
                }
                title={t("LoggedHome.NoRecentActivities")}
                content={t("LoggedHome.MovingOrganization")}
            />
        </Grid>
    )
}